import styled from "@emotion/styled";
import { Text } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledToggleContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const StyledToggleBlock = styled.label({
  display: "flex",
  alignItems: "center",
});

export const StyledHelperText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
